import { SVGProps } from 'react';

const DownloadIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={40} height={41} viewBox='0 0 40 41' fill='none' {...props}>
    <path
      d='M9.2207 15.7741L20.0004 26.5553L30.7816 15.7741H24.792V4.99284C24.792 4.67513 24.6658 4.37044 24.4412 4.14578C24.2165 3.92113 23.9118 3.79492 23.5941 3.79492H16.4066C16.0889 3.79492 15.7842 3.92113 15.5596 4.14578C15.3349 4.37044 15.2087 4.67513 15.2087 4.99284V15.7741H9.2207Z'
      stroke='#94B0C5'
      strokeWidth={2}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M37.9707 28.9512V33.7428C37.9707 34.3783 37.7183 34.9876 37.269 35.4369C36.8197 35.8863 36.2103 36.1387 35.5749 36.1387H4.42904C3.79362 36.1387 3.18423 35.8863 2.73493 35.4369C2.28562 34.9876 2.0332 34.3783 2.0332 33.7428V28.9512'
      stroke='#94B0C5'
      strokeWidth={2}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export default DownloadIcon;
